import { DateTime } from "luxon";

export default class DateUtil {
    public static MINUTE_AS_MS = 60 * 1000;
    public static HOUR_AS_MS = 60 * DateUtil.MINUTE_AS_MS;
    public static DAY_AS_MS = 24 * DateUtil.HOUR_AS_MS;

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------


    // This method will get the current local time as an ISO string. 
    public static getCurrentDateTimeIsoString(): string {
        const time = new Date();
        const timeZoneOffSet = time.getTimezoneOffset() * 60 * 1000;
        const timeLocal = Date.now() - timeZoneOffSet;
        return (new Date(timeLocal).toISOString());
    }

    public static getCurrentMsDate(roundUpToSecond: boolean = true): number {
        if (roundUpToSecond) {
            return Math.ceil(new Date().getTime() / 1000) * 1000;
        }
        return new Date().getTime();
    }

    public static getExpiration(
        minutesFromNow: number,
        roundToSecond: boolean = true
    ): number {
        return (
            DateUtil.getCurrentMsDate(roundToSecond) +
            minutesFromNow * DateUtil.MINUTE_AS_MS
        );
    }

    public static isFutureDate(
        dateInMilliseconds?: number,
        defaultIfNull: boolean = false
    ): boolean {
        if (dateInMilliseconds == null) {
            return defaultIfNull;
        }
        return dateInMilliseconds > new Date().getTime();
    }

    public static isPastDate(
        dateInMilliseconds?: number,
        defaultIfNull: boolean = false
    ): boolean {
        if (dateInMilliseconds == null) {
            return defaultIfNull;
        }
        return dateInMilliseconds < new Date().getTime();
    }

    public static isExpired(
        dateInMilliseconds?: number,
        defaultIfNull: boolean = true
    ): boolean {
        return DateUtil.isPastDate(dateInMilliseconds, defaultIfNull);
    }

    public static isToday(
        dateAsMilliseconds?: number | null,
        defaultIfNull: boolean = false
    ): boolean {
        if (dateAsMilliseconds == null || isNaN(dateAsMilliseconds)) {
            return defaultIfNull;
        }

        const date = new Date(dateAsMilliseconds);
        const now = new Date();

        return now.toLocaleDateString() === date.toLocaleDateString();
    }

    public static isBeforeToday(
        dateAsMilliseconds?: number,
        defaultIfNull: boolean = false
    ): boolean {
        if (dateAsMilliseconds == null || isNaN(dateAsMilliseconds)) {
            return defaultIfNull;
        }
        if (DateUtil.isToday(dateAsMilliseconds)) {
            return false;
        }
        return dateAsMilliseconds < new Date().getTime();
    }

    public static isGreaterThanOneDay(date: DateTime): boolean {
        const yesterday = DateTime.now().minus({ day: 1 });

        return !(date > yesterday.startOf("day"));
    }

    // Gets the difference between the date passed and now in days.
    public static getDifferenceBetweenDate = (dateOne: number) => {
        const subDate = new Date((dateOne * 1000));
        const now = new Date();
        const differenceInTime = now.getTime() - subDate.getTime();
        // Calculating the no. of days between
        // two dates
        const differenceInDays =
            Math.round
                (differenceInTime / (1000 * 3600 * 24));
        return differenceInDays;
    }

    // #endregion Public Methods
}
